module.exports = __webpack_public_path__ + "static/img/black-avatar.d8b47a3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activityManage/black-avatar.svg
// module id = KALx
// module chunks = 1